import { makeStyles } from "@material-ui/core/styles"
import { green } from "@material-ui/core/colors"

const useStyles = makeStyles((theme) => ({
  buttonPrimary: {
    textTransform: "none",
    backgroundColor: theme.palette.primary200,
    color: theme.palette.neutral100,
    borderRadius: "12px",
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "none",
    gap: "8px",
    padding: "8px 16px",

    "&:hover": {
      background: `linear-gradient(0deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.05) 100%), var(--blue-blue-200, ${theme.palette.primary200})`,
    },
    "&:disabled": {
      background: `linear-gradient(0deg, rgba(255, 255, 255, 0.50) 0%, rgba(255, 255, 255, 0.50) 100%), var(--blue-blue-200, ${theme.palette.primary200})`,
      color: theme.palette.neutral100,
    },
    "&:focus": {
      border: `2px solid ${theme.palette.primary100}`,
    },
  },
  buttonSecondary: {
    textTransform: "none",
    backgroundColor: theme.palette.background300,
    color: theme.palette.primary200,
    borderRadius: "12px",
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "none",
    gap: "8px",
    border: `1px solid ${theme.palette.primary200}`,
    padding: "8px 16px",

    "&:hover": {
      background: `linear-gradient(0deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.05) 100%), ${theme.palette.background300}`,
    },

    "&:disabled": {
      background: `linear-gradient(0deg, rgba(255, 255, 255, 0.50) 0%, rgba(255, 255, 255, 0.50) 100%), ${theme.palette.background300}`,
      color: theme.palette.primary100,
    },

    "&:focus": {
      border: `2px solid ${theme.palette.primary100}`,
    },
  },
  buttonTertiary: {
    textTransform: "none",
    backgroundColor: "",
    color: theme.palette.primary200,
    borderRadius: "12px",
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "none",
    gap: "8px",
    border: "none",
    padding: "8px 16px",

    "&:hover": {
      background: "rgba(0, 0, 0, 0.05)",
    },

    "&:disabled": {
      background: `linear-gradient(0deg, rgba(255, 255, 255, 0.50) 0%, rgba(255, 255, 255, 0.50) 100%)`,
      color: theme.palette.primary100,
    },

    "&:focus": {
      border: `2px solid ${theme.palette.primary100}`,
    },
  },
  buttonContact: {
    textTransform: "none",
    backgroundColor: theme.palette.background300,
    color: theme.palette.primary200,
    borderRadius: "12px",
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "none",
    gap: "8px",
    border: `1px solid ${theme.palette.primary200}`,
    padding: "8px 16px",
    marginBottom: "4px",

    "&:hover": {
      background: `linear-gradient(0deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.05) 100%), ${theme.palette.background300}`,
    },

    "&:disabled": {
      background: `linear-gradient(0deg, rgba(255, 255, 255, 0.50) 0%, rgba(255, 255, 255, 0.50) 100%), ${theme.palette.background300}`,
      color: theme.palette.blue100,
    },
  },
  buttonDanger: {
    textTransform: "none",
    backgroundColor: theme.palette.feedbackError100,
    color: theme.palette.neutral100,
    borderRadius: "12px",
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "none",
    gap: "8px",
    border: "none",
    padding: "8px 16px",

    "&:hover": {
      background: `linear-gradient(0deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.05) 100%), ${theme.palette.feedbackError100}`,
    },

    "&:disabled": {
      background: `linear-gradient(0deg, rgba(255, 255, 255, 0.50) 0%, rgba(255, 255, 255, 0.50) 100%), ${theme.palette.feedbackError100}`,
      color: theme.palette.neutral100,
    },

    "&:focus": {
      border: `2px solid ${theme.palette.primary100}`,
    },
  },
  buttonText: {
    textTransform: "none",
    backgroundColor: "transparent",
    color: theme.palette.primary200,
    borderRadius: "12px",
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "none",
    border: "none",
    "&:hover": {
      background: "transparent",
      opacity: 0.8,
    },
    "&:disabled": {
      color: theme.palette.primary100,
    },
  },
}))

export default useStyles
